import 'rmc-dialog/assets/index.css';
import './modal.scss';
import React, { Component } from 'react';
import Dialog from 'rmc-dialog';
import PropTypes from 'prop-types';

const propTypes = {
  visible: PropTypes.bool,
  // 锁定显示，适用于当前页中需要永久留存的，仅需要隐藏掉的组件，而不是直接去除dom
  lockVisible: PropTypes.bool,
  center: PropTypes.bool,
  wrapClassName: PropTypes.string
};

const defaultProps = {
  center: true,
  lockVisible: false
};

export default class Modal extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      center,
      bodyStyle,
      wrapClassName,
      ...restProps
    } = this.props;
    const prefixCls = 'lf-modal';
    const wrapCls = [wrapClassName, center ? `${prefixCls}--center` : ''].join(' ');

    return (
      <Dialog
        prefixCls={prefixCls}
        wrapClassName={wrapCls}
        closable={false}
        bodyStyle={Object.assign({ padding: '10px 20px' }, bodyStyle)}
        {...restProps}
      />
    );
  }
}

Modal.defaultProps = defaultProps;
Modal.propTypes = propTypes;
